import { render } from "./NavPopover.vue?vue&type=template&id=087f96fa"
import script from "./NavPopover.vue?vue&type=script&lang=js"
export * from "./NavPopover.vue?vue&type=script&lang=js"

import "./NavPopover.vue?vue&type=style&index=0&id=087f96fa&lang=css"
script.render = render

export default script